import { capitaliseMakeModel } from '@/general/helpers/capitaliseMakeModel.helpers';
import { FilterListPayload, Model } from '@/types/CarFilters.types';

export const processFilterListPayload = (filterListPayload: FilterListPayload) => {
  const { makeAndModel: makeAndModelRaw, ...filters } = filterListPayload;

  return {
    makeAndModel: processMakeAndModel(makeAndModelRaw),
    ...filters,
  };
};

const processMakeAndModel = (makeAndModel: Model[]) => {
  // Recursively go through the makeAndModel array and return a new array with the make and model
  return makeAndModel.map((item): Model => {
    item.label = capitaliseMakeModel(item.label);

    if (item.models) {
      return {
        ...item,
        models: processMakeAndModel(item.models),
      };
    }

    return item;
  });
};
